/* eslint-disable no-use-before-define */
import { cancel, cancelled, call, take, fork, put } from 'redux-saga/effects'
import { eventChannel } from 'redux-saga'
import ItemOptionActions, { ItemOptionTypes } from '../reducers/itemOptionReducer'
import firebase from '../config/firebase'

export function* getItemOptions({ storeId }) {
  const itemOptionsListener = yield fork(itemOptionObserver, storeId)

  yield take(ItemOptionTypes.GET_ITEM_OPTIONS_DISCONNECTED)
  yield cancel(itemOptionsListener)
}

export function* itemOptionObserver(storeId) {
  const ref = firebase
    .firestore()
    .collection('item_options')
    .where('store_id', '==', storeId)

  const channel = yield call(observer, ref)
  try {
    while (true) {
      const snapshot = yield take(channel)

      if (Object.keys(snapshot).length > 0) {
        yield put(ItemOptionActions.getItemOptionsConnected(storeId, snapshot))
      } else {
        yield put(ItemOptionActions.getItemOptionsConnected(storeId, {}))
      }
    }
  } catch (err) {
    yield put(ItemOptionActions.getItemOptionsError(err))
  } finally {
    if (yield cancelled()) {
      channel.close()
    }
  }
}

const observer = ref => {
  const listener = eventChannel(emit => {
    const subscriber = ref.onSnapshot(
      querySnapshot => {
        const itemOptions = {}

        querySnapshot.forEach(doc => {
          itemOptions[doc.id] = { ...doc.data(), id: doc.id }
        })

        emit(itemOptions)
      },
      err => {
        emit(new Error(err))
      }
    )

    return () => subscriber
  })
  return listener
}



// WEBPACK FOOTER //
// ./src/sagas/itemOptionSaga.js